const tabIdsEn = {
    stocks: 'stocks',
    transactions: 'transactions',
    realized: 'realized',
    dividends: 'dividends',
    performance: 'performance',
    allocation: 'allocation',
    kennzahlen: 'key-figures',
    'gewinn-und-verlust': 'profit-and-loss',
    bilanz: 'balance-sheet',
    cashflow: 'cashflow',
    ergebnis: 'earnings',
    personalized: 'personalized',
    sentiment: 'sentiment',
    'basic-materials': 'basic-materials',
    'communication-services': 'communication-services',
    'consumer-cyclical': 'consumer-cyclical',
    'consumer-defensive': 'consumer-defensive',
    energy: 'energy',
    'financial-services': 'financial-services',
    healthcare: 'healthcare',
    industrials: 'industrials',
    'real-estate': 'real-estate',
    technology: 'technology',
    utilities: 'utilities',
}

const tabIdsDe = {
    stocks: 'aktien',
    transactions: 'transaktionen',
    realized: 'realisierte',
    dividends: 'dividenden',
    performance: 'performance',
    allocation: 'zuteilung',
    kennzahlen: 'kennzahlen',
    'gewinn-und-verlust': 'gewinn-und-verlust',
    bilanz: 'bilanz',
    cashflow: 'cashflow',
    ergebnis: 'ergebnis',
    personalized: 'personalisiert',
    sentiment: 'marktstimmung',
    'basic-materials': 'grundstoffe',
    'communication-services': 'kommunikationsdienste',
    'consumer-cyclical': 'zyklische-konsumguter',
    'consumer-defensive': 'nichtzyklische-konsumguter', 
    energy: 'energie',
    'financial-services': 'finanzwesen',
    healthcare: 'gesundheitswesen',
    industrials: 'industrie',
    'real-estate': 'immobilien',
    technology: 'informationstechnologie',
    utilities: 'versorger',
}

const tabIdsEs = {
    stocks: 'acciones',
    transactions: 'transacciones',
    realized: 'realizadas',
    dividends: 'dividendos',
    performance: 'rendimiento',
    allocation: 'asignación',
    kennzahlen: 'indicadores-clave',
    'gewinn-und-verlust': 'ganancias-y-perdidas',
    bilanz: 'balance',
    cashflow: 'flujo-de-caja',
    ergebnis: 'resultados',
    personalized: 'personalizado',
    sentiment: 'sentimiento',
    'basic-materials': 'materiales-basicos',
    'communication-services': 'servicios-de-comunicacion',
    'consumer-cyclical': 'bienes-de-consumo-ciclicos',
    'consumer-defensive': 'bienes-de-consumo-basicos',
    energy: 'energia',
    'financial-services': 'servicios-financieros',
    healthcare: 'salud',
    industrials: 'industria',
    'real-estate': 'bienes-raices',
    technology: 'tecnologias-de-la-informacion',
    utilities: 'servicios-publicos',
}

const tabIdsFr = {
    stocks: 'actions',
    transactions: 'transactions',
    realized: 'realisees',
    dividends: 'dividendes',
    performance: 'performance',
    allocation: 'allocation',
    kennzahlen: 'indicateurs-cles',
    'gewinn-und-verlust': 'gains-et-pertes',
    bilanz: 'bilan',
    cashflow: 'flux-de-trésorerie',
    ergebnis: 'résultats',
    personalized: 'personnalise',
    sentiment: 'sentiment',
    'basic-materials': 'materiaux-de-base',
    'communication-services': 'services-de-communication',
    'consumer-cyclical': 'biens-de-consommation-cycliques',
    'consumer-defensive': 'biens-de-consommation-de-base',
    energy: 'energie',
    'financial-services': 'services-financiers',
    healthcare: 'sante',
    industrials: 'industrie',
    'real-estate': 'immobilier',
    technology: 'technologies-de-l-information',
    utilities: 'services-aux-collectivites',
}

// NOTE: DO NOT let any urlPathSegments object contain keys that have same value
const urlPathSegmentsEn = {
    aktie: 'stock',
    share: 'share',
    fundamentaldaten: 'fundamentaldata',
    news: 'news',
    checkout: 'checkout',
    create: 'create',
    success: 'success',
    feature: 'feature',
    individuelle: 'individual',
    assets: 'assets',
    finance: 'finance',
    dashboard: 'dashboard',
    portfolio: 'portfolio',
    automatisch: 'auto',
    importieren: 'import',
    'subscription': 'subscription',
    feedback: 'feedback',
    maintenance: 'maintenance',
    user: 'user',
    settings: 'settings',
    profile: 'profile',
    'market-analysis': 'market-analysis',
    login: 'login',
    sandbox: 'sandbox',
    'fin-agent': 'fin-agent',
    thread: 'thread',
    message: 'message',
    library: 'library',
    snippet: 'snippet',
    watchlist: 'watchlist',
    'sector-reports': 'sector-reports',
    'market-data': 'market-data',
    recurring: 'recurring',
    home: 'home',
    ...tabIdsEn
};

const urlPathSegmentsDe = {
    aktie: 'aktie',
    share: 'share',
    fundamentaldaten: 'fundamentaldaten',
    news: 'nachrichten',
    checkout: 'kasse',
    create: 'erstellen',
    success: 'erfolg',
    feature: 'feature',
    individuelle: 'individuelle',
    assets: 'assets',
    finance: 'finanzen',
    dashboard: 'uebersicht',
    portfolio: 'portfolio',
    automatisch: 'automatisch',
    importieren: 'importieren',
    'subscription': 'abo',
    feedback: 'feedback',
    maintenance: 'wartung',
    user: 'benutzer',
    settings: 'einstellungen',
    profile: 'profil',
    'market-analysis': 'marktanalyse',
    login: 'anmelden',
    sandbox: 'virtual',
    'fin-agent': 'fin-agent',
    thread: 'thread',
    message: 'nachricht',
    library: 'bibliothek',
    snippet: 'ausschnitt',
    watchlist: 'watchlist',
    'sector-reports': 'sektoren',
    'market-data': 'marktdaten',
    recurring: 'wiederkehrend',
    home: 'start',
    ...tabIdsDe
}

const urlPathSegmentsEs = {
    aktie: 'compartir',
    share: 'accion',
    fundamentaldaten: 'datos-fundamentales',
    news: 'noticias',
    checkout: 'caja',
    create: 'crear',
    success: 'exito',
    feature: 'característica',
    individuelle: 'individual',
    assets: 'activos',
    finance: 'finanzas',
    dashboard: 'tablero',
    portfolio: 'portafolio',
    automatisch: 'automático',
    importieren: 'importar',
    'subscription': 'suscripcion',
    feedback: 'retroalimentacion',
    maintenance: 'mantenimiento',
    user: 'usuario',
    settings: 'configuracion',
    profile: 'perfil',
    'market-analysis': 'analisis-de-mercado',
    login: 'acceso',
    sandbox: 'salvadera',
    'fin-agent': 'fin-agent',
    thread: 'hilo',
    message: 'mensaje',
    library: 'biblioteca',
    snippet: 'fragmento',
    watchlist: 'lista-de-vigilancia',
    'sector-reports': 'informes-sectoriales',
    'market-data': 'datos-de-mercado',
    recurring: 'recurrencia',
    home: 'hogar',
    ...tabIdsEs
};

const urlPathSegmentsFr = {
    aktie: 'partager',
    share: 'action',
    fundamentaldaten: 'donnees-fondamentales',
    news: 'actualites',
    checkout: 'caisse',
    create: 'creer',
    success: 'succes',
    feature: 'fonctionnalite',
    individuelle: 'individuel',
    assets: 'actifs',
    finance: 'finance',
    dashboard: 'tableau-de-bord',
    portfolio: 'portefeuille',
    automatisch: 'automatique',
    importieren: 'importer',
    'subscription': 'abonnement',
    feedback: 'retour',
    maintenance: 'maintenance',
    user: 'utilisateur',
    settings: 'parametres',
    profile: 'profil',
    'market-analysis': 'analyse-de-marche',
    login: 'se-connecter',
    sandbox: 'virtuel',
    'fin-agent': 'fin-agent',
    thread: 'fil',
    message: 'mensaje',
    library: 'bibliotheque',
    snippet: 'extrait',
    watchlist: 'liste-de-surveillance',
    'sector-reports': 'rapports-sectoriels',
    'market-data': 'donnees-marche',
    recurring: 'recurrence',
    home: 'maison',
    ...tabIdsFr,
};

const urlPathSegments = {
    en: urlPathSegmentsEn,
    de: urlPathSegmentsDe,
    es: urlPathSegmentsEs,
    fr: urlPathSegmentsFr
};

const tabIds = {
    en: tabIdsEn,
    de: tabIdsDe,
    es: tabIdsEs,
    fr: tabIdsFr
};

const originalPublicRoutePaths = [
    'user-mgmt',
    'maintenance',
    'aktie',
    'market-analysis',
    'login',
];

// Paths that navigate from the Vue Website to Wordpress Website
// Currently, we just have English and German
const externalPathsEn = {
    signup: 'signup',
    imprint: 'imprint',
    'data-privacy': 'data-privacy',
    'blog': 'blog',
    changelog: 'changelog',
};

const externalPathsDe = {
    signup: 'signup',
    imprint: 'impressum',
    'data-privacy': 'datenschutz',
    'blog': 'blog',
    changelog: 'changelog',
};

const externalPaths = {
    en: externalPathsEn,
    de: externalPathsDe,
    es: externalPathsEn,
    fr: externalPathsEn
};

export default {
    urlPathSegments,
    originalPublicRoutePaths,
    tabIds,
    externalPaths
}